import { motion } from "framer-motion";

const STATS = [
  { value: "5+", label: "Years of Experience" },
  { value: "03", label: "Major Indian Cities" },
  { value: "100+", label: "Projects Delivered" },
  { value: "10+", label: "Skilled Employees" },
];

export default function Stats() {
  return (
    <section id="stats" className="border-y border-white/10 bg-navy-800/40" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className={`py-14 lg:py-20 px-4 lg:px-10 ${i > 0 ? "border-l border-white/10" : ""} ${i > 1 ? "border-t lg:border-t-0 border-white/10" : ""}`}
            data-testid={`stat-${i}`}
          >
            <p className="font-mono-accent text-4xl md:text-5xl lg:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-slate-100 to-electric">
              {stat.value}
            </p>
            <p className="font-mono-accent text-[10px] md:text-xs tracking-[0.25em] uppercase text-slate-500 mt-4">
              {stat.label}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
